import React, { useState, useEffect } from 'react';
import { RelatedItem, RelatedList, RelatedFilter } from '../common';
import { sortAsc } from '@helpers/numHelpers';
import { RelatedItemTag, RelatedItem as RelatedItemType } from '@layouts/Related/Related.types';

interface RelatedServiceContainerProps {
  content: RelatedItemType[];
  blockContent: string;
  contentStandard: RelatedItemType[];
  styleType: string;
  contentType: string;
  I18n: Record<string, string>;
  hideServiceList: boolean;
}

export const RelatedServiceContainer = ({
  content,
  blockContent,
  contentStandard,
  styleType,
  contentType,
  I18n,
  hideServiceList,
}: RelatedServiceContainerProps) => {
  const [filterTag, setFilterTag] = useState<RelatedItemTag>({ id: 0, name: 'All' });
  const [filterTagStandard, setFilterTagStandard] = useState<RelatedItemTag>({
    id: 0,
    name: 'All',
  });
  const [filters, setFilters] = useState<RelatedItemTag[]>([]);
  const [filtersStandard, setFiltersStandard] = useState<RelatedItemTag[]>([]);

  useEffect(() => {
    let initfilters: RelatedItemTag[] = [];
    let initfiltersStandard: RelatedItemTag[] = [];
    let inittags: RelatedItemType[] = [];
    let inittagsStandard: RelatedItemType[] = [];

    if (content) {
      inittags = content.filter((item) => item.Tags);
    }

    if (contentStandard) {
      inittagsStandard = contentStandard.filter((item) => item.Tags);
    }

    /* Iterate all tags */
   
      inittags.forEach(function (items) {
        items.Tags?.forEach(function (item) {
          initfilters.push(item);
        });
      });
    
      inittagsStandard.forEach(function (items) {
        items.Tags?.forEach(function (item) {
          initfiltersStandard.push(item);
        });
      });
    

    if (initfilters.length > 0) {
      const stringFilters = initfilters.map((item) => JSON.stringify(item));
      const uniqueStringFilters = new Set(stringFilters);
      initfilters = [];
      uniqueStringFilters.forEach((item) => initfilters.push(JSON.parse(item)));
      initfilters.sort(sortAsc);
      setFilters(initfilters);
    }

    if (initfiltersStandard.length > 0) {
      const stringFiltersStandard = initfiltersStandard.map((item) => JSON.stringify(item));
      const uniqueStringFiltersStandard = new Set(stringFiltersStandard);
      initfiltersStandard = [];
      uniqueStringFiltersStandard.forEach((item) => initfiltersStandard.push(JSON.parse(item)));
      initfiltersStandard.sort(sortAsc);
      setFiltersStandard(initfiltersStandard);
    }
  }, []);

  const updateFilterTag = (filterTag: RelatedItemTag) => {
    setFilterTag(filterTag);
  };

  const updateFilterTagStandard = (filterTagStandard: RelatedItemTag) => {
    setFilterTagStandard(filterTagStandard);
  };

  return (
    <>
      {!content && !blockContent ? null : !contentStandard && !blockContent ? null : (
        <div className='l-section l-section-100'>
          {blockContent && (
            <div className='l-page' dangerouslySetInnerHTML={{ __html: blockContent }} />
          )}
          {!hideServiceList && (
            <>
              <RelatedFilter
                tags={filters}
                i18n={I18n}
                isBound
                className='is-related'
                contentType={contentType}
                onTagClick={updateFilterTag}
              />
              <RelatedList
                styleType={styleType}
                items={content}
                i18n={I18n}
                filterTag={filterTag}
              />
            </>
          )}

          <RelatedFilter
            tags={filtersStandard}
            i18n={I18n}
            isBound
            className='is-related'
            contentType={contentType}
            onTagClick={updateFilterTagStandard}
          />
          <RelatedList
            styleType={styleType}
            items={contentStandard}
            i18n={I18n}
            filterTag={filterTagStandard}
          />
        </div>
      )}
    </>
  );
};
